import * as UI from "@iyk/ui"
import * as Carousel from "./ui/carousel.tsx"

import { each } from "@iyk/flow"
import { Video } from "../ui/video.tsx"
import { SectionLayout } from "./ui/section-layout.tsx"

export const GetStarted = () => {
  return (
    <SectionLayout size="fluid" theme="light" className="bg-white">
      <div className="flex flex-col gap-y-12 py-[104px] max-w-[100rem] mx-auto">
        <h3 className="text-balance max-w-48 pl-4 md:pl-14">Get started in 3 simple steps</h3>
        <Steps />
      </div>
    </SectionLayout>
  )
}

// #region Steps

const Steps = () => {
  return (
    <Carousel.Root
      options={CAROUSEL_OPTIONS}
      className="flex flex-col items-center justify-center gap-6 md:block md:px-14"
    >
      <Carousel.Slides
        className={{
          viewport: "px-4 md:px-0",
          container: "-ml-4 md:-ml-10",
        }}
      >
        {each(SLIDES, (slide, index) => (
          <Carousel.Slide
            key={slide.title}
            className="flex flex-col gap-4 flex-[0_0_calc(100%-2rem)] md:flex-[0_0_calc(100%/3)] pl-4 md:pl-10"
          >
            <UI.Stack>
              <UI.Layer>
                <Video className="w-full aspect-square bg-gray-3" aria-hidden="true">
                  <source src={slide.media.src.mp4} type="video/mp4" />
                </Video>
              </UI.Layer>
              <UI.Layer className="z-10 pointer-events-none">
                <h4
                  className="ml-1 mt-1 size-6 text-center content-center text-xs-upper bg-white slashed-zero"
                  aria-label={`Step ${index + 1}`}
                >{`${String(index + 1).padStart(2, "0")}`}</h4>
              </UI.Layer>
            </UI.Stack>
            <div className="flex flex-col gap-1">
              <span className="text-xs-upper">{slide.title}</span>
              <span className="text-sm">{slide.description}</span>
            </div>
          </Carousel.Slide>
        ))}
      </Carousel.Slides>
      <Carousel.Controls className="gap-2" />
    </Carousel.Root>
  )
}

const CAROUSEL_OPTIONS: Carousel.CarouselOptions = {
  breakpoints: {
    "(max-width: 767px)": {
      align: "start",
    },
    "(min-width: 768px)": {
      active: false,
    },
  },
}

const SLIDES: Slide[] = [
  {
    title: "Tap",
    description: "Tap the cyberphysical card to get started",
    media: {
      alt: "Tap card",
      src: {
        mp4: "https://assets.iyk-dev.app/postcards/getting_started/getting_started-1of3-tap.mp4",
      },
    },
  },
  {
    title: "Create",
    description: "Record or upload your video message—solo or with others",
    media: {
      alt: "Record video",
      src: {
        mp4: "https://assets.iyk-dev.app/postcards/getting_started/getting_started-2of3-create.mp4",
      },
    },
  },
  {
    title: "Sign & seal",
    description: "Embed your video message into the card and mail it via post",
    media: {
      alt: "Mail card",
      src: {
        mp4: "https://assets.iyk-dev.app/postcards/getting_started/getting_started-3of3-sign_and_seal.mp4",
      },
    },
  },
]

type Slide = {
  title: string
  description: string
  media: SlideMedia
}

type SlideMedia = {
  src: {
    mp4: string
  }
  alt: string
}

// #endregion
